import { Card, Container, Table, TableContainer, TablePagination } from '@mui/material';
import DataTableRow from '@src/components/data-table/data-row';
import TableHeader from '@src/components/data-table/header';
import Scrollbar from '@src/components/scrollbar';
import { useSubscriptionContext } from './provider';
import { useSubscriptionService } from './hooks';
import TableRowItem from './table-row';
import Toolbar from './toolbar';

const TABLE_HEAD = [
  { id: 'u.id', label: 'User ID', align: 'left' },
  { id: 'displayName', label: 'Display Name', align: 'left' },
  { id: 'planType', label: 'Plan', align: 'left' },
  { id: 'amount', label: 'Amount', align: 'left' },
  { id: 'status', label: 'Status', align: 'left' },
  { id: 'startedAt', label: 'Start On', align: 'left' },
  { id: 'expiresAt', label: 'Expires On (Auto)', align: 'left' },
  { id: '', label: 'Action', align: 'center' },
];

const Body = () => {
  const { data, subscriptions, isLoading, isRefreshing } = useSubscriptionService();
  const { state, handlePageChange, handleRequestSort, handleRowsPerPageChange } = useSubscriptionContext();

  return (
    <Container>
      <Toolbar />
      <Card sx={{ borderRadius: '25px', px: '23px', py: '10px' }}>
        <Scrollbar>
          <TableContainer sx={{ overflowX: 'auto' }}>
            <Table>
              <TableHeader
                order={state.order}
                orderBy={state.orderBy}
                headLabel={TABLE_HEAD}
                onRequestSort={handleRequestSort}
              />
              <DataTableRow
                colSpan={TABLE_HEAD.length}
                data={subscriptions}
                isLoading={isLoading}
                isRefreshing={isRefreshing}
                headers={TABLE_HEAD}
                filterName={state.search}
                renderItem={({ item, index }: any) => (
                  <TableRowItem key={index} {...item} />
                )}
              />
            </Table>
          </TableContainer>
        </Scrollbar>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50]}
          page={state.page || 0}
          component="div"
          rowsPerPage={state.rowsPerPage || 10}
          count={data?.totalRecords ?? 0}
          onPageChange={handlePageChange}
          onRowsPerPageChange={handleRowsPerPageChange}
        />
      </Card>
    </Container>
  );
};

export default Body;
